import { render, staticRenderFns } from "./SliderMulti.vue?vue&type=template&id=0c252ba8&scoped=true&lang=pug&"
import script from "./SliderMulti.vue?vue&type=script&lang=ts&"
export * from "./SliderMulti.vue?vue&type=script&lang=ts&"
import style0 from "./SliderMulti.vue?vue&type=style&index=0&id=0c252ba8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c252ba8",
  null
  
)

export default component.exports